var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "is-full-screen": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    attrs: {
      "id": "lineHaulContent"
    }
  }, [_c('h3', {
    staticClass: "h3-center-text"
  }, [_vm._v("LineHaul Details "), _c('span', {
    staticClass: "float-right"
  }, [_c('router-link', {
    staticStyle: {
      "padding-right": "10px",
      "cursor": "pointer",
      "color": "#424242"
    },
    attrs: {
      "to": {
        name: 'confirmlinehaulconnection'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Go Back"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplay),
      expression: "isDisplay"
    }]
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Coloader Name :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.coloadername) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Route Mode :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.routemode) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Name :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.vehiclename) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Number :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.vehicleno) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("AWB No :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.awbno) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("PC's (Total Bags) :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.pcs) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Total Coloader Phy Wt. :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.physicalweight) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Total Coloader Vol Wt. :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.volumetricweight) + " ")])]), _vm._v(" "), (_vm.lineHaulObjData.routemode == 'Train' || _vm.lineHaulObjData.routemode == 'train') ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Boggie No :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.boggieno) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Break No :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.breakno) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Train Type :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.traintype) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.lineHaulObjData.routemode == 'Train' || _vm.lineHaulObjData.routemode == 'train') ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("RR No :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.rrno) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("First RR No :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.rrno1) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Second RR No :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.rrno2) + " ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Departure Date :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lineHaulObjData.departuredate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Departure Time :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.departuretime) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Schedule Date :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lineHaulObjData.scheduledate)) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Arrival Date :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lineHaulObjData.arrivaldate)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Arrival Time :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.arrivaltime))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm.printDate))]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.printBy))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('strong', [_vm._v("XPRESSBEES LINE HAUL BAG DETAILS SHEET")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Connection Name :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.connectionname) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Route Mode :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.routemode) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Number :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.vehicleno) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Departure Date :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lineHaulObjData.departuredate)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Departure Time :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.departuretime) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("No of Bags :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.lineHaulObjData.noofbags) + " ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Sr. No.")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Bag Type")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Bag No")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Total Shipments")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Destination Hub")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Phy. Wt.")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vol. Wt.")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Remarks")])])]), _vm._v(" "), _vm._l((_vm.lineHaulShipmentObjData), function(each, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(each.bagtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(each.bagno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(each.totalshipments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(each.destinationhubname) + "(" + _vm._s(each.destinationhubid) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(each.physicalweight) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(each.volumetricweight))]), _vm._v(" "), _c('td')])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('strong', [_vm._v("Total Vol. Wt. : ")]), _vm._v(_vm._s(_vm.TotalVolWt) + "   \n                      "), _c('strong', [_vm._v("Total Phy. Wt. : ")]), _vm._v(_vm._s(_vm.TotalPhyWt) + "   \n                      "), _c('strong', [_vm._v("Total Line Haul Bags : ")]), _vm._v(_vm._s(_vm.TotalLineHaulBags) + "   \n                      "), _c('strong', [_vm._v("Total Bags : ")]), _vm._v(_vm._s(_vm.TotalBags) + "   \n                      "), _c('strong', [_vm._v("Total Shipments : ")]), _vm._v(_vm._s(_vm.TotalShipments) + "   \n                    ")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "height": "80px"
    }
  }, [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n                      Driver's Sign\n                    ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                      Receiver's Sign\n                    ")])])], 2)])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplay),
      expression: "isDisplay"
    }],
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.printLineHaul()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print Line Haul")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendMail()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Send Mail")])])]), _vm._v(" "), (_vm.showemailpage == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Send Mail"
    },
    model: {
      value: (_vm.showemailpage),
      callback: function($$v) {
        _vm.showemailpage = $$v
      },
      expression: "showemailpage"
    }
  }, [_c('fieldset', [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Send Mail")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSendMailPage
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mail ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-envelope'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailId),
      expression: "mailId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('mailId')
    },
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "name": "mailId",
      "id": "mailId",
      "placeholder": "Enter MailId, Use Comma For Multiple MailId's"
    },
    domProps: {
      "value": (_vm.mailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailId = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.emailIdErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdErrorMSG))]) : _vm._e(), _vm._v(" "), (_vm.emailIdValidationMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdValidationMSG))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.SendMailFunction
    }
  }, [_vm._v("Send Mail")]), _vm._v(" \n                        "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset Mail")]), _vm._v(" \n\n                      ")])])])])])])])]) : _vm._e()], 1)])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56585f2e","hasScoped":true}!./src/views/components/LineHaulPrint/LineHaulPrint.html
// module id = 909
// module chunks = 2